<template>
    <div
        class='current-sub-details'>
        <sim-plan-display :sim-info="simInfo" :sub-id="subId" v-if="showCurrentPlan"></sim-plan-display>
    </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import SimPlanDisplay from './SimPlanDisplay.vue';
import { SimManager } from '@/lib/simManager';

export default Vue.extend({

    components: {
        SimPlanDisplay,
    },
    props: {
        currentSubscriptionTitle: String,
        simInfo: Object as PropType<SimManager|null>,
        subId: String,
    },
    data() {

        return {
            showCurrentPlan: true
        };

    }

});

</script>

<style lang="less" scoped>
    .current-sub-details{
        font-family: @font_02;
        margin-bottom: 15px;
        .current-title-wrapper{
            display: flex;
            align-items: center;
            margin-bottom: 15px;
            gap: 4px;
            .current-title{
                font-size: 24px;
                font-weight: 600;
                overflow-wrap: break-word;
                @media @mobile{
                    font-size: 18px;
                }
            }
            .operator-wrapper{
                display: flex;
                align-items: center;
                color: @brand_light;
                @media @snapeak_pc{
                    &:hover{
                        cursor: pointer;
                        color: @brand_light_hover;
                    }
                }
                @media @snapeak_mobile {
                    &:active{
                        color: @brand_light_hover;
                    }
                }
            }
        }
        .separator{
            border: 1px solid @line;
            margin: 24px 0;
        }
        .switch-title{
            margin-top: 50px;
            font-size: 20px;
            font-weight: 700;
            @media @mobile{
                font-size: 18px;
                margin-top: 30px;
            }
        }
        .note{
            font-size: 14px;
        }
    }
</style>
